import React from 'react'
import Bloque from '../layout/bloque'
import Column from '../layout/column'
import Tarjeta from './index'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import './animations.css'

export default ({
  tarjetas,
  countryAbr,
  whatsapp,
  formUrl,
  multicanalidad,
}) => {
  return (
    <Bloque>
      <TransitionGroup className="tarjetas-grid">
        {tarjetas.map(tarjeta => (
          <CSSTransition
            key={tarjeta.id}
            timeout={500}
            classNames="animacion-tarjeta"
          >
            <Column
              division={{ mobile: 1, tablet: 3, desktop: 3 }}
              rowSpacing={0}
            >
              <Tarjeta
                tarjeta={tarjeta}
                countryAbr={countryAbr}
                whatsapp={whatsapp}
                formUrl={formUrl}
                multicanalidad={multicanalidad}
              />
            </Column>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </Bloque>
  )
}
